<template>
  <div>
    <b-modal v-model="showModal"
      :title="title"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="card shadow">
              <form autocomplete="off">
                <div class="card-body">
                  <div class="container">

                    <!-- ==================== EXAMEN EN CURSO ==================== -->
                    <div v-if="!finished">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-2"><i class="fas fa-tasks"></i>&nbsp;&nbsp;<b><u class="section-title">Preguntas y Respuestas: </u></b></div>
                        </div>
                        <div class="col-md-6 text-right">
                          <div><b>Tiempo:</b> {{ countUp.minutes.toString().padStart(2, '0') }}:{{ countUp.seconds.toString().padStart(2, '0') }}  </div>
                        </div>
                      </div>
                      <b-overlay :show="loading" rounded="sm">
                        <div class="bg-text mb-2 p-1 exam-question" v-for="(question, index) in questions" :key="index">

                          <div class="mb-2">
                            <div class="question-line">
                              <b>{{ index + 1 }})</b>
                              <span class="question-html" v-html="question.question"></span>
                            </div>
                            <!-- mostrar el codigo si es un estudiante de prueba -->
                            <span v-if="question.user_role_id === 7" style="font-size: 8px;">
                               &nbsp; - Código: {{ question.code }}
                            </span>
                          </div>

                          <div v-if="question.image" class="text-center mb-2">
                            <img
                              :src="question.image"
                              alt="Imagen de la pregunta"
                              style="max-width: 100%; max-height: 300px; object-fit: contain;"
                              class="b-radius shadow"
                            >
                          </div>


                          <!-- Mismas clases que la revisión del panel de resultados -->
                          <div v-for="(answer, i) in question.options" :key="i"
                            class="review-option exam-option"
                            :class="optionFeedbackClass(question, answer)">
                            <i v-if="showFeedback(question)" class="review-option-icon"
                              :class="answer.selection == 1 ? 'fas fa-check text-success' : (isPicked(question, answer) ? 'fas fa-times text-danger' : 'far fa-circle')"></i>
                            <label class="exam-option-label">
                              <input :type="question.typeanswer"
                                  :value="answer.value"
                                  @change="updateForm(question, answer, $event)"
                                  :name="question.id" :disabled="question.answered">
                              <span class="answer-text" v-html="answer.answer"></span>
                              <!-- mostrar el codigo si es un estudiante de prueba -->
                              <span v-if="question.user_role_id === 7" style="font-size: 8px;">
                                &nbsp; - Código: {{ answer.code }}
                              </span>
                            </label>
                            <span v-if="optionTag(question, answer)" class="review-option-tag">{{ optionTag(question, answer) }}</span>
                          </div>

                          <div class="row">
                            <div v-if="showFeedback(question)" class="col-12 mt-2">
                              <span class="badge" :class="feedbackByQuestion[question.id].correct ? 'badge-success' : 'badge-danger'">
                                {{ feedbackByQuestion[question.id].correct ? 'Tu respuesta es correcta' : 'Tu respuesta es incorrecta' }}
                              </span>

                              <div v-if="!feedbackByQuestion[question.id].correct && (question.explanation || question.explanation_img)" class="review-explanation">
                                <div class="review-explanation-title"><i class="fas fa-lightbulb"></i> Por qué es la correcta</div>
                                <div v-if="question.explanation" class="review-explanation-text" v-html="question.explanation"></div>
                                <div v-if="question.explanation_img" class="text-center mt-2">
                                  <img
                                    :src="question.explanation_img"
                                    alt="Imagen de explicación"
                                    style="max-width: 100%; max-height: 300px; object-fit: contain;"
                                    class="b-radius shadow"
                                  >
                                </div>

                                <!-- <div v-if="question.explanation_video" class="text-center mt-2 mb-2">
                                  <video controls style="max-width: 100%; max-height: 350px;">
                                    <source :src="question.explanation_video" type="video/mp4">
                                  </video>
                                </div> -->
                              </div>
                            </div>
                            <div class="col-12 text-right">
                              <hr>
                              <div>
                                <span class="color-text" style="font-size: 6px;">{{ question.code }}</span>
                                <!-- Sin respuesta marcada no se puede verificar: antes se podía
                                     y la pregunta se contaba como fallada sin haber contestado -->
                                <small v-if="countUp.minutes<=34 && !question.answered && !hasSelection(question)" class="text-muted mr-2">
                                  Selecciona una respuesta
                                </small>
                                <button v-if="countUp.minutes<=34" class="btn btn-sm btn-primary"
                                  @click.prevent="checkAnswer(question, question.options)"
                                  :disabled="question.answered || !hasSelection(question)"><i class="fas fa-share"></i> Verificar Respuesta</button>
                              </div>
                              <cite v-if="countUp.minutes>=35" class="text-danger"><b>El tiempo máximo de 35 minutos para el examen ha sido alcanzado.</b></cite>
                            </div>
                          </div>
                        </div>
                        <div class="row p-1">
                          <div class="col-12 text-right">
                            <button class="btn btn-success " @click.prevent="submitForm()" :disabled="saving"><i class="fas fa-share-square"></i> Finalizar Examen</button>
                          </div>
                        </div>
                      </b-overlay>
                    </div>

                    <!-- ==================== RESULTADOS ==================== -->
                    <div v-else-if="results">

                      <div class="row" ref="resultsTop">
                        <div class="col-12 mb-2">
                          <i class="fas fa-chart-pie"></i>&nbsp;&nbsp;<b><u class="section-title">Resultado del examen {{ typeExamen == 'municipal' ? 'municipal' : 'de práctica' }}</u></b>
                        </div>
                      </div>

                      <!-- Indicadores -->
                      <div class="kpi-grid mb-3">
                        <div class="kpi-card">
                          <div class="kpi-icon" :style="{ backgroundColor: colors.primary }"><i class="fas fa-star"></i></div>
                          <div class="kpi-body">
                            <div class="kpi-value">{{ results.pointsEarned }} / {{ results.pointsPossible }}</div>
                            <div class="kpi-label">Puntos obtenidos</div>
                          </div>
                        </div>
                        <div class="kpi-card">
                          <div class="kpi-icon" :style="{ backgroundColor: percentColor }"><i class="fas fa-percent"></i></div>
                          <div class="kpi-body">
                            <div class="kpi-value">{{ results.percent }}%</div>
                            <div class="kpi-label">Rendimiento del examen</div>
                          </div>
                        </div>
                        <div class="kpi-card">
                          <div class="kpi-icon" :style="{ backgroundColor: colors.success }"><i class="fas fa-check"></i></div>
                          <div class="kpi-body">
                            <div class="kpi-value">{{ results.correct }}</div>
                            <div class="kpi-label">Correctas de {{ results.total }}</div>
                          </div>
                        </div>
                        <div class="kpi-card">
                          <div class="kpi-icon" :style="{ backgroundColor: colors.danger }"><i class="fas fa-times"></i></div>
                          <div class="kpi-body">
                            <div class="kpi-value">{{ results.wrong }}</div>
                            <div class="kpi-label">Incorrectas</div>
                          </div>
                        </div>
                        <div class="kpi-card">
                          <div class="kpi-icon" :style="{ backgroundColor: colors.secondary }"><i class="fas fa-minus"></i></div>
                          <div class="kpi-body">
                            <div class="kpi-value">{{ results.unanswered }}</div>
                            <div class="kpi-label">Sin responder</div>
                          </div>
                        </div>
                      </div>

                      <!-- Aviso: preguntas que nunca se verificaron -->
                      <div v-if="results.unanswered" class="alert-reliability">
                        <i class="fas fa-exclamation-triangle"></i>
                        Dejaste <b>{{ results.unanswered }}</b> {{ results.unanswered === 1 ? 'pregunta sin verificar' : 'preguntas sin verificar' }}.
                        No suman puntos: recuerda pulsar <b>Verificar Respuesta</b> en cada pregunta antes de finalizar.
                      </div>

                      <!-- Una sección sin datos no se muestra; la que quede ocupa toda la fila -->
                      <div class="row" v-if="showDonut || showLevels">
                        <div v-if="showDonut" :class="chartColClass" class="mb-2">
                          <div class="panel-block">
                            <div class="panel-title">Distribución de respuestas</div>
                            <div ref="donutChart"></div>
                          </div>
                        </div>
                        <div v-if="showLevels" :class="chartColClass" class="mb-2">
                          <div class="panel-block">
                            <div class="panel-title">Desempeño por dificultad</div>
                            <div ref="levelChart"></div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-6 mb-2">
                          <div class="panel-block">
                            <div class="panel-title">Tiempo y ritmo</div>
                            <div class="review-stat">
                              <span>Tiempo empleado</span>
                              <b>{{ formatSeconds(results.timeSeconds) }} <span class="review-stat-soft">/ 35:00</span></b>
                            </div>
                            <div class="progress-mini mb-2">
                              <div class="progress-mini-bar" :style="{ width: timePercent + '%', backgroundColor: results.timedOut ? colors.danger : colors.info }"></div>
                            </div>
                            <div class="review-stat" v-if="results.answered">
                              <span>Promedio por pregunta respondida</span>
                              <b>{{ formatSeconds(results.avgSeconds) }}</b>
                            </div>
                            <div class="review-stat">
                              <span>Preguntas respondidas</span>
                              <b>{{ results.answered }} de {{ results.total }}</b>
                            </div>
                            <div v-if="results.timedOut" class="text-danger mt-2" style="font-size: 0.82rem;">
                              <i class="fas fa-clock"></i> Se alcanzó el tiempo máximo de 35 minutos.
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 mb-2">
                          <div class="panel-block">
                            <div class="panel-title">Impacto en el módulo</div>
                            <div class="review-stat">
                              <span>Puntaje del módulo</span>
                              <b>{{ moduleScoreAfter }} / 100</b>
                            </div>
                            <div class="progress-mini progress-mini--threshold mb-2">
                              <div class="progress-mini-bar" :style="{ width: moduleScoreAfter + '%', backgroundColor: moduleScoreAfter >= 75 ? colors.success : colors.warning }"></div>
                            </div>
                            <div class="review-stat">
                              <span>Antes de este examen</span>
                              <b>{{ moduleScoreBefore }}</b>
                            </div>
                            <div class="review-stat">
                              <span>Sumaste con este examen</span>
                              <b class="text-success">+{{ moduleScoreAfter - moduleScoreBefore }}</b>
                            </div>
                            <div v-if="moduleScoreAfter >= 75" class="text-success mt-2" style="font-size: 0.82rem;">
                              <i class="fas fa-unlock"></i> Ya alcanzaste los 75 puntos que exige el módulo. Completa la lectura y la práctica para desbloquear el siguiente.
                            </div>
                            <div v-else class="mt-2" style="font-size: 0.82rem; color: #8a5a1a;">
                              <i class="fas fa-lock"></i> Te faltan <b>{{ 75 - moduleScoreAfter }}</b> puntos para llegar a los 75 que exige el módulo.
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Revisión detallada: en los dos tipos de examen. Lo que el
                           municipal no revela es el feedback DURANTE el examen. -->
                      <div class="mt-3">
                        <div class="mb-2">
                          <i class="fas fa-list-ul"></i>&nbsp;&nbsp;<b><u class="section-title">Revisión de las preguntas que no acertaste</u></b>
                        </div>

                        <div v-if="!results.review.length" class="panel-block text-center">
                          <i class="fas fa-award" :style="{ color: colors.success, fontSize: '1.6rem' }"></i>
                          <div class="mt-2"><b>¡Perfecto!</b> Acertaste todas las preguntas de este examen.</div>
                        </div>

                        <div v-for="item in results.review" :key="item.number" class="review-card">
                          <div class="review-card-head">
                            <span class="badge" :class="item.state === 'wrong' ? 'badge-danger' : 'badge-secondary'">
                              {{ item.state === 'wrong' ? 'Incorrecta' : 'Sin responder' }}
                            </span>
                            <span class="review-card-num">Pregunta {{ item.number }}</span>
                          </div>

                          <div class="review-question" v-html="item.question"></div>

                          <div v-if="item.image" class="text-center mb-2">
                            <img :src="item.image" alt="Imagen de la pregunta"
                              style="max-width: 100%; max-height: 240px; object-fit: contain;" class="b-radius shadow">
                          </div>

                          <div v-for="option in item.options" :key="option.id"
                            class="review-option"
                            :class="{
                              'review-option--correct': option.correct,
                              'review-option--picked': option.selected && !option.correct
                            }">
                            <i class="review-option-icon"
                              :class="option.correct ? 'fas fa-check text-success' : (option.selected ? 'fas fa-times text-danger' : 'far fa-circle')"></i>
                            <span class="answer-text" v-html="option.answer"></span>
                            <span v-if="option.selected && option.correct" class="review-option-tag">tu respuesta &middot; correcta</span>
                            <span v-else-if="option.selected" class="review-option-tag">tu respuesta</span>
                            <span v-else-if="option.correct" class="review-option-tag">respuesta correcta</span>
                          </div>

                          <div v-if="item.explanation || item.explanation_img" class="review-explanation">
                            <div class="review-explanation-title"><i class="fas fa-lightbulb"></i> Por qué es la correcta</div>
                            <div v-if="item.explanation" class="review-explanation-text" v-html="item.explanation"></div>
                            <div v-if="item.explanation_img" class="text-center mt-2">
                              <img :src="item.explanation_img" alt="Imagen de explicación"
                                style="max-width: 100%; max-height: 260px; object-fit: contain;" class="b-radius shadow">
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-danger" type="button" @click="close">&nbsp;<i class="fas fa-times fa-fw"></i>Cerrar&nbsp;</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BOverlay } from 'bootstrap-vue';
import { BModal } from 'bootstrap-vue';

// Misma paleta que los dashboards (Dashboard/Panel.vue y Dashboard/StudentPanel.vue)
const COLORS = {
  primary:   '#00b5b8',
  success:   '#16d39a',
  info:      '#2dcee3',
  warning:   '#ffa87d',
  danger:    '#ff7588',
  secondary: '#404e67',
};

// Orden con el que se muestran los niveles de dificultad en la gráfica
const LEVEL_ORDER = ['Facil', 'Fácil', 'Intermedio', 'Dificil', 'Difícil'];

// Duración máxima del examen, en minutos
const MAX_MINUTES = 35;

// Puntaje de módulo que exige el sistema para desbloquear el siguiente
const MODULE_THRESHOLD = 75;

export default {
  components: {BModal, BOverlay},
  props: ['data', 'showModal', 'typeExamen'],
  data() {
    return {
      form: {},
      loading: false,
      questions: [],
      title: null,
      moduleProgress: [],
      // Selección del alumno indexada por pregunta. Antes era un único buffer
      // global que se pisaba al cambiar de pregunta.
      responsesByQuestion: {},
      // Resultado de cada pregunta ya verificada: {correct: bool}. Sustituye a la
      // manipulación directa del DOM (getElementById + classList) que había antes.
      feedbackByQuestion: {},
      answersCheck: [], // Variable para almacenar las respuestas
      // Variables para el cronómetro
      hours: 0,
      minutes: 0,
      seconds: 0,
      timeString: '00:00:00', // Variable para mostrar el tiempo en formato HH:MM:SS
      timer: null, // Variable para almacenar el temporizador
      countTime: null, // Variable para almacenar el tiempo guardado
      readTime: null,
      practiceTime: null,
      questionId: null,
      questionResult: false,
      scoreTotal: 0,
      countUp: {
        minutes: 0,
        seconds: 0,
        timer: null,
      },
      // Estado de la pantalla de resultados
      saving: false,
      finished: false,
      results: null,
      moduleScoreBefore: 0,
      moduleScoreAfter: 0,
      charts: [],
      colors: COLORS,
    }
  },
  computed: {
    isTimerRunning() {
      return this.countUp.timer !== null;
    },
    // Color del indicador de rendimiento del examen
    percentColor() {
      if (!this.results) return COLORS.info;
      if (this.results.percent >= 75) return COLORS.success;
      if (this.results.percent >= 50) return COLORS.warning;
      return COLORS.danger;
    },
    // Secciones sin datos no se muestran
    showDonut() {
      return !!this.results && this.results.total > 0;
    },
    showLevels() {
      // Solo si alguna pregunta trae nivel real: si ninguna lo tiene, la
      // gráfica sería una única barra "Sin nivel" que no dice nada.
      return !!this.results && this.results.hasLevels;
    },
    chartColClass() {
      return (this.showDonut && this.showLevels) ? 'col-lg-6' : 'col-lg-12';
    },
    // Porcentaje del tiempo máximo consumido
    timePercent() {
      if (!this.results) return 0;
      const percent = Math.round((this.results.timeSeconds / (MAX_MINUTES * 60)) * 100);
      return percent > 100 ? 100 : percent;
    },
  },
  mounted(){
    this.title = "Practica de Módulo: "+this.data.module;
    this.moduleProgress = this.data.moduleProgress;
    this.moduleScoreBefore = this.data.moduleProgress.score;
    this.readTime = this.data.read_time;
    this.practiceTime = this.data.practice_time;
    this.getQuestions(this.data.id)
    this.playProgress();
    this.startCountUp();
  },
  created() {
    // Estado del ciclo de vida, NO reactivo a propósito: solo lo usa el guardado
    // de los temporizadores pendientes de whenReady.
    this.pendingTimers = [];
    this.isGone = false;
  },
  beforeDestroy() {
    // El botón Cerrar destruye el componente (Container.vue lo monta con v-if).
    // Si queda alguna espera de whenReady viva, seguiría corriendo hasta 5s y
    // podría montar una gráfica sobre nodos ya desconectados del DOM.
    this.isGone = true;
    this.pendingTimers.forEach(id => clearInterval(id));
    this.pendingTimers = [];
    this.destroyCharts();
  },
  methods:{
    stripHtml(html) {
      if (!html) return ''
      return html.replace(/<[^>]*>/g, '')
    },
    formatSeconds(totalSeconds) {
      const seconds = Math.max(0, Math.round(totalSeconds || 0));
      const minutes = Math.floor(seconds / 60);
      return minutes.toString().padStart(2, '0') + ':' + (seconds % 60).toString().padStart(2, '0');
    },
    close(bvModalEvent) {
      this.timerCounter('stop');
      this.saveModuleProgress(this.moduleProgress.id, this.countTime, this.data.courseid)
    },
    getQuestions(moduleId) {
      this.loading = true
      if(moduleId) {
        axios.get(`/getQuestions/${moduleId}`)
        .then(response => {
          // 'answered' se declara aquí: si se añadiera después, Vue 2 no la haría
          // reactiva y el :disabled del botón Verificar nunca se actualizaría.
          this.questions = response.data.map(question => Object.assign({}, question, { answered: false }));

          // Los mapas se construyen con TODAS las claves y se asignan enteros:
          // así son reactivos desde el primer render (Vue 2).
          const responses = {};
          const feedback = {};
          this.questions.forEach(question => {
            responses[question.id] = [];
            feedback[question.id] = null;
          });
          this.responsesByQuestion = responses;
          this.feedbackByQuestion = feedback;
        })
        .finally(() => {
          this.loading = false
        });
      }
    },
    saveModuleProgress(id, countTime, courseid) {
      let status = null;

      let readPrecent = this.precentTime(this.readTime, this.data.moduleProgress.read_time);
      let practicePrecent = this.precentTime(this.practiceTime, countTime);

      if(readPrecent>=100 && practicePrecent>=100 && this.data.moduleProgress.status==1 && this.data.moduleProgress.score>=MODULE_THRESHOLD){
        status = 2;
      }

      axios.post('/saveModuleProgress', { id: id, practice_time: countTime, status: status, courseid: courseid })
        .then(response => {
            if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
            };
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
          this.$emit('loadProgress', this.moduleProgress.id );
          this.$emit('update:showModal', false);
          });
    },
    playProgress(){
      this.timerCounter('play', this.moduleProgress.practice_time);
    },
    timerCounter(control, startTime) {
      if (control === 'play') {
        this.timer = setInterval(() => {
          this.seconds++;
          if (this.seconds >= 60) {
            this.seconds = 0;
            this.minutes++;
            if (this.minutes >= 60) {
              this.minutes = 0;
              this.hours++;
            }
          }
          this.timeString = this.formatTime(this.hours, this.minutes, this.seconds);
          localStorage.setItem('practice_time', this.timeString);
          this.countTime = this.timeString
        }, 1000);
      } else if (control === 'pause') {
        clearInterval(this.timer);
        // Guardar el tiempo actual en una variable
        localStorage.setItem('practice_time', this.timeString);
      } else if (control === 'stop') {
        clearInterval(this.timer);
        // Restablecer el cronómetro
        this.seconds = 0;
        this.minutes = 0;
        this.hours = 0;
        this.timeString = '00:00:00';
        // Guardar el tiempo actual en una variable
        localStorage.setItem('practice_time', this.timeString);
      }
      // Si se proporciona un tiempo de inicio, establecer el cronómetro en ese tiempo
      if (startTime) {
        const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
        this.hours = startHours;
        this.minutes = startMinutes;
        this.seconds = startSeconds;
        this.timeString = startTime;
      }
    },
    formatTime(hours, minutes, seconds) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    //Convierte el tiempo string a fomarto date para comprar el tiempo base y el tiempo acumulado
    convertSeconds(time) {
      const partsTime = time.split(":");
      return partsTime[0] * 3600 + partsTime[1] * 60 + partsTime[2] * 1;
    },
    //Se calcula el procentaje en base al tiempo requerido y el tiempo acumulado
    precentTime(practiceTime, practice_time_progress){
      let result = 0;
      if(this.convertSeconds(practice_time_progress) >= this.convertSeconds(practiceTime)){
        return result = 100;
      }else{
        // Convertir tiempo requerido y progreso a segundos totales
        const timerequeredSeconds = this.convertSeconds(practiceTime);
        const progressSeconds = this.convertSeconds(practice_time_progress);
        // Calcular el porcentaje
        let percent = Math.round((progressSeconds / timerequeredSeconds) * 100);
        result = percent === 100 ? percent.toString() : percent.toString().padStart(2, '0');
        return result;
      }
    },
    //capturar los radiobutton o checkbox seleccionados o deseleccionados
    updateForm(question, answer, event) {
      // Copia de la selección actual de ESTA pregunta
      const current = (this.responsesByQuestion[question.id] || []).slice();

      if (question.typeanswer === 'Checkbox') {
        const isChecked = event.target.checked;
        if (isChecked) {
            // Si la casilla de verificación está marcada, añadir el ID
            current.push({ id: answer.id, selection: answer.selection });
        } else {
            // Si la casilla de verificación está desmarcada, eliminar el ID
            const index = current.findIndex(item => item.id === answer.id);
            if (index !== -1) {
                current.splice(index, 1);
            }
        }
        this.$set(this.responsesByQuestion, question.id, current);
      }else{
        // Radio: una única opción por pregunta
        this.$set(this.responsesByQuestion, question.id, [{ id: answer.id, selection: answer.selection }]);
      }
    },
    checkAnswer(question, answers) {
      // Sin esta guarda una pregunta podía verificarse dos veces y sumar el doble
      if (question.answered) return;

      let count = 0;
      this.questionResult = false;

      const responses = this.responsesByQuestion[question.id] || [];

      answers.forEach(answer => {
        // Busca si la respuesta seleccionada por el usuario está entre las respuestas correctas
        const isCorrect = responses.find(response => response.id === answer.id);

        // Si la respuesta seleccionada por el usuario está entre las respuestas correctas, aumenta el contador
        if (isCorrect && isCorrect.selection === 1) {
            count++;
        }

        if (isCorrect && isCorrect.selection === 0) {
          count--;
        }

      });

      if (count === question.answer_number) {
        this.scoreTotal = this.scoreTotal + question.score;
        this.questionResult = true;
      }

      // El feedback lo pinta el template a partir de este estado
      this.$set(this.feedbackByQuestion, question.id, { correct: this.questionResult });

      this.answersCheck.push({ id: question.id, answer: question.options, selection: responses, answeredCorrectly: this.questionResult});

      this.questionId = question.id;
      question.answered = true;
    },
    // ---- Ayudantes del feedback por pregunta ----
    hasSelection(question) {
      return (this.responsesByQuestion[question.id] || []).length > 0;
    },
    // El feedback por pregunta solo se revela en el examen de práctica
    showFeedback(question) {
      return this.typeExamen == 'practico' && !!this.feedbackByQuestion[question.id];
    },
    isPicked(question, answer) {
      return (this.responsesByQuestion[question.id] || []).some(item => item.id === answer.id);
    },
    optionFeedbackClass(question, answer) {
      if (!this.showFeedback(question)) return '';
      if (answer.selection == 1) return 'review-option--correct';
      return this.isPicked(question, answer) ? 'review-option--picked' : '';
    },
    optionTag(question, answer) {
      if (!this.showFeedback(question)) return '';
      const picked = this.isPicked(question, answer);
      const correct = answer.selection == 1;
      if (picked && correct) return 'tu respuesta \u00b7 correcta';
      if (picked) return 'tu respuesta';
      return correct ? 'respuesta correcta' : '';
    },
    /**
     * Arma las estadísticas del intento a partir de las preguntas servidas y de
     * lo que el alumno llegó a verificar. Una pregunta que nunca se verificó no
     * cuenta como fallada: es su propia categoría ('sin responder').
     */
    buildResults() {
      const checked = {};
      this.answersCheck.forEach(item => { checked[item.id] = item; });

      let correct = 0, wrong = 0, unanswered = 0, pointsPossible = 0;
      let hasLevels = false;
      const levels = {};
      const review = [];

      this.questions.forEach((question, index) => {
        pointsPossible += Number(question.score) || 0;

        // Toda pregunta cae en un bucket, así que byLevel nunca queda vacío:
        // hace falta una bandera aparte para saber si hay niveles de verdad.
        const level = question.questionlevel || 'Sin nivel';
        if (question.questionlevel) hasLevels = true;
        if (!levels[level]) levels[level] = { level: level, ok: 0, total: 0 };
        levels[level].total++;

        const entry = checked[question.id];
        let state;
        if (!entry) {
          state = 'unanswered';
          unanswered++;
        } else if (entry.answeredCorrectly) {
          state = 'correct';
          correct++;
          levels[level].ok++;
        } else {
          state = 'wrong';
          wrong++;
        }

        if (state === 'correct') return;

        const picked = entry ? entry.selection.map(item => item.id) : [];
        review.push({
          number: index + 1,
          state: state,
          question: question.question,
          image: question.image,
          explanation: question.explanation,
          explanation_img: question.explanation_img,
          options: (question.options || []).map(option => ({
            id: option.id,
            answer: option.answer,
            correct: option.selection == 1,
            selected: picked.indexOf(option.id) !== -1,
          })),
        });
      });

      const total = this.questions.length;
      const answered = correct + wrong;
      const timeSeconds = this.countUp.minutes * 60 + this.countUp.seconds;

      const byLevel = Object.keys(levels)
        .map(key => levels[key])
        .sort((a, b) => {
          const ia = LEVEL_ORDER.indexOf(a.level);
          const ib = LEVEL_ORDER.indexOf(b.level);
          return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
        });

      this.results = {
        total: total,
        correct: correct,
        wrong: wrong,
        unanswered: unanswered,
        answered: answered,
        pointsEarned: this.scoreTotal,
        pointsPossible: pointsPossible,
        percent: pointsPossible > 0 ? Math.round((this.scoreTotal / pointsPossible) * 100) : 0,
        byLevel: byLevel,
        hasLevels: hasLevels,
        timeSeconds: timeSeconds,
        avgSeconds: answered > 0 ? Math.round(timeSeconds / answered) : 0,
        timedOut: this.countUp.minutes >= MAX_MINUTES,
        review: review,
      };
    },
    /**
     * Espera a una condición REAL del DOM, no a un tick.
     *
     * `b-modal` renderiza su contenido a través de un portal (BVTransporter),
     * un componente hijo montado aparte en <body> que se actualiza un tick
     * DESPUÉS que este componente. Por eso `$nextTick` no basta: al ejecutarse,
     * las refs del panel de resultados todavía no existen y el código
     * imperativo (gráficas, scroll) se ejecutaba en vacío, sin error visible.
     *
     * Cubre además que apexcharts.min.js se carga en el layout después de
     * mix('js/app.js').
     */
    whenReady(check, callback, timeoutMs = 5000) {
      if (this.isGone) return;
      if (check()) return callback();

      let waited = 0;
      const retry = setInterval(() => {
        // El modal pudo cerrarse mientras esperábamos: no seguir tocando el DOM
        if (this.isGone) return this.clearPendingTimer(retry);

        if (check()) {
          this.clearPendingTimer(retry);
          callback();
        } else if ((waited += 50) >= timeoutMs) {
          this.clearPendingTimer(retry);
          console.error('El panel de resultados no llegó a montarse a tiempo.');
        }
      }, 50);

      this.pendingTimers.push(retry);
    },
    clearPendingTimer(id) {
      clearInterval(id);
      const index = this.pendingTimers.indexOf(id);
      if (index !== -1) this.pendingTimers.splice(index, 1);
    },
    /**
     * Al finalizar, el modal conserva el scroll donde estaba (a media revisión).
     * Se apunta a .modal-body (b-modal lleva `scrollable`) en vez de usar solo
     * scrollIntoView, para no arrastrar también el scroll de la página de fondo.
     */
    scrollResultsToTop() {
      const el = this.$refs.resultsTop;
      if (!el) return;

      const body = el.closest('.modal-body');
      if (body) {
        body.scrollTop = 0;
      } else {
        el.scrollIntoView({ block: 'start' });
      }
    },
    destroyCharts() {
      this.charts.forEach(chart => { if (chart) chart.destroy() });
      this.charts = [];
    },
    renderCharts() {
      this.destroyCharts();
      this.renderDonut();
      this.renderLevels();
    },
    renderDonut() {
      const el = this.$refs.donutChart;
      if (!el || !this.results) return;

      const chart = new window.ApexCharts(el, {
        chart: { type: 'donut', height: 250, animations: { enabled: false } },
        labels: ['Correctas', 'Incorrectas', 'Sin responder'],
        series: [this.results.correct, this.results.wrong, this.results.unanswered],
        colors: [COLORS.success, COLORS.danger, COLORS.secondary],
        legend: { position: 'bottom' },
        plotOptions: {
          pie: { donut: { labels: { show: true, total: { show: true, label: 'Preguntas' } } } },
        },
      });
      chart.render();
      this.charts.push(chart);
    },
    renderLevels() {
      const el = this.$refs.levelChart;
      if (!el || !this.showLevels) return;

      const chart = new window.ApexCharts(el, {
        chart: { type: 'bar', height: 250, animations: { enabled: false }, toolbar: { show: false } },
        series: [{
          name: '% de acierto',
          data: this.results.byLevel.map(item => item.total ? Math.round((item.ok / item.total) * 100) : 0),
        }],
        colors: [COLORS.primary],
        plotOptions: { bar: { horizontal: true, barHeight: '55%' } },
        dataLabels: { enabled: true, formatter: value => value + '%' },
        xaxis: {
          categories: this.results.byLevel.map(item => item.level + ' (' + item.ok + '/' + item.total + ')'),
          max: 100,
        },
      });
      chart.render();
      this.charts.push(chart);
    },
    submitForm() {
      if (this.saving) return;
      this.saving = true;

      this.stopCountUp();
      this.timerCounter('stop');

      const examData = {
        mycourseId: this.data.moduleProgress.mycourse_id,
        moduleId: this.data.id,
        questions: this.questions,
        answers: this.answersCheck,
        time: this.countUp.minutes.toString().padStart(2, '0')+':'+this.countUp.seconds.toString().padStart(2, '0'),
        score: this.scoreTotal,
        courseid: this.data.courseid,
        type: this.typeExamen,
      };

      axios.post('/saveTest', examData)
      .then(response => {
        // El examen ya quedó guardado; si el modal se cerró mientras tanto,
        // no hay nada que pintar.
        if (this.isGone) return;

        if (response.data.status == 'error') {
          toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          this.saving = false;
        } else {
          toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });

          // El puntaje del módulo lo devuelve el servidor ya acumulado (tope 100).
          // Se refleja en el objeto en memoria para que el desbloqueo del módulo
          // en close() evalúe el valor nuevo y no el que llegó al abrir el modal.
          this.moduleScoreAfter = response.data.moduleScore;
          this.data.moduleProgress.score = response.data.moduleScore;

          this.buildResults();
          this.finished = true;
          this.title = "Resultado del examen: " + this.data.module;

          // Dos esperas independientes: si ApexCharts fallara, el scroll igual se hace.
          this.whenReady(() => !!this.$refs.resultsTop, () => this.scrollResultsToTop());
          this.whenReady(
            () => !!window.ApexCharts && !!this.$refs.resultsTop,
            () => this.renderCharts()
          );
        }
      })
      .catch(error => {
        console.error(error);
        if (this.isGone) return;
        // Sin este aviso el alumno no recibe ninguna señal y vuelve a pulsar
        // Finalizar una y otra vez. Sus respuestas siguen en memoria: reintentar
        // no pierde nada.
        toastr.error(
          'No se pudo guardar el examen. Revisa tu conexión e inténtalo de nuevo.',
          'Error', { icon: 'fa fa-times-circle' }
        );
        this.saving = false;
      })
      .finally(() => {
        this.loading = false;
      });
    },
    //Reloj para contar los 35min que dura el test
    startCountUp() {
      this.countUp.timer = setInterval(() => {
        if (this.countUp.minutes === MAX_MINUTES && this.countUp.seconds === 0) {
          // Era this.countdown.timer, propiedad inexistente: lanzaba TypeError
          // y el cronómetro seguía corriendo pasado el límite.
          clearInterval(this.countUp.timer);
          this.countUp.timer = null;
          this.timerCounter('stop');
          return;
        }

        if (this.countUp.seconds === 59) {
          this.countUp.minutes++;
          this.countUp.seconds = 0;
        } else {
          this.countUp.seconds++;
        }
      }, 1000);
    },
    stopCountUp() {
      clearInterval(this.countUp.timer);
      this.countUp.timer = null;
    }
  },
}
</script>
<style>
/* El número "N)" debe quedar en la misma línea que el inicio del enunciado, pero los
   párrafos siguientes de CKEditor tienen que seguir siendo bloques: si se inlinean
   todos, el enunciado y la pregunta final se funden en un solo flujo de texto. */
.question-line .question-html > p:first-child {
  display: inline;
}
.question-line .question-html > p {
  margin: 0 0 .5rem;
}
.question-line .question-html > p:last-child {
  margin-bottom: 0;
}

/* Revisión de resultados: aquí no hay número, todos los párrafos son bloque. */
.review-question p {
  margin: 0 0 .5rem;
}
.review-question p:last-child {
  margin-bottom: 0;
}

/* Respuestas: el texto arranca junto al radio, pero admite varios párrafos. */
.answer-text > p:first-child {
  display: inline;
}
.answer-text > p {
  margin: 0 0 .35rem;
}
.answer-text > p:last-child {
  margin-bottom: 0;
}
</style>
